<template>
  <v-card class="client-request-create-modal">
    <v-card-title class="client-request-create-modal__heading">Please, check all information again and confirm request</v-card-title>

    <scrollable-container>
      <data-row>
        <v-flex>
          <one-data-column>
            <data-label
              slot="label"
              highlight
            >Client</data-label>
            <div class="t-create-client font-weight-medium">{{ profile.name || profile.id }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Subject</data-label>
            <div class="t-create-subject">{{ clientRequestData.subject }}</div>
          </one-data-column>

          <one-data-column>
            <data-label slot="label">Message</data-label>
            <div class="t-create-message">{{ clientRequestData.requestMessage }}</div>
          </one-data-column>

          <div v-if="hasAttachedFiles">
            <one-data-column :label-props="{ style: 'display: none;' }">
              <data-divider />
            </one-data-column>

            <one-data-column>
              <data-label slot="label">Attached files</data-label>
              <attachment-button
                v-for="(file, index) in clientRequestData.documents"
                :key="index"
                :href="formatDocumentUrl(profile, file.id)"
              >{{ file.name }}</attachment-button>
            </one-data-column>
          </div>
        </v-flex>
      </data-row>
    </scrollable-container>

    <v-divider class="grey lighten-3" />

    <v-card-actions class="client-request-create-modal__actions">
      <v-btn
        class="t-create-request"
        color="primary"
        flat="flat"
        :disabled="createClientRequestApiRequest.loading"
        @click="onConfirmButtonClick"
      >create request</v-btn>

      <v-btn
        class="t-close-modal"
        color="primary"
        flat="flat"
        :disabled="createClientRequestApiRequest.loading"
        @click="closeModal"
      >cancel</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'

  // Utils
  import { createClientRequestListRoute } from '@/utils/routing/ClientRequests'

  // Events
  import { EVENT_CLIENT_REQUEST_CREATE } from '@/events/clientRequests'

  // Services
  import ApiRequest from '@/services/ApiRequests/ApiRequest'
  import ClientRequestApi from '@/services/Api/ClientRequestApi'

  // Mixins
  import documentStorage from '@/mixins/documentStorage'

  // Components
  import ScrollableContainer from '@/components/ui/ScrollableContainer'
  import DataRow from '@/components/ui/Data/DataRow'
  import OneDataColumn from '@/components/ui/Data/OneDataColumn'
  import DataLabel from '@/components/ui/Data/DataLabel'
  import AttachmentButton from '@/components/ui/AttachmentButton'
  import DataDivider from '@/components/ui/Data/DataDivider'

  export default {
    name: 'ClientRequestCreateModal',
    components: {
      ScrollableContainer,
      AttachmentButton,
      DataRow,
      OneDataColumn,
      DataLabel,
      DataDivider
    },
    mixins: [documentStorage],
    data () {
      return {
        createClientRequestApiRequest: new ApiRequest(ClientRequestApi.create)
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      profile () {
        return this.modal.data.profile
      },
      clientRequestData () {
        return this.modal.data.clientRequest
      },
      hasAttachedFiles () {
        return this.clientRequestData.documents != null && this.clientRequestData.documents.length > 0
      }
    },
    methods: {
      ...mapActions('modal', ['showModal', 'closeModal']),
      createClientRequestListRoute,
      onConfirmButtonClick () {
        this.createClientRequest()
          .then(this.showSuccessFlashModal)
          .catch(error => {
            this.$eventHub.$emit(EVENT_CLIENT_REQUEST_CREATE, error)
            this.showErrorFlashModal()
          })
      },
      createClientRequest () {
        return this.createClientRequestApiRequest.execute(this.profile.id, this.clientRequestData)
      },
      showSuccessFlashModal () {
        this.showModal({
          name: 'SuccessFlashModal',
          data: {
            redirectPath: createClientRequestListRoute(),
            message: 'Client request has been successfully created.'
          }
        })
      },
      showErrorFlashModal () {
        this.showModal({
          name: 'ErrorFlashModal',
          data: {
            message: 'Client request has not been created.'
          }
        })
      }
    }
  }
</script>

<style lang="scss">
  .client-request-create-modal {
    font-size: 16px;
    font-weight: 400;

    &__heading,
    .container {
      padding-right: 30px;
      padding-left: 30px;
    }

    &__heading {
      font-size: 24px;
      font-weight: 400;
      line-height: 32px;
      padding-top: 21px;
    }

    &__actions {
      padding: 14px 14px;
    }
  }
</style>
